import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utilities from "./utilities/utility";
import fb from "./firebaseConfig.js";
import { firestorePlugin } from "vuefire";
import VueTheMask from "vue-the-mask";
import ToggleButton from "vue-js-toggle-button";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "./registerServiceWorker";

Vue.component("v-select", vSelect);
Vue.use(VueTheMask);
Vue.use(Loading);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);
Vue.use(ToggleButton);
Vue.mixin(utilities.mixin());

Vue.config.productionTip = false;

let app;
fb.auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      store: store,
      router,
      render: (h) => h(App),
      created() {
        if (user) {
          return store.dispatch("getProducts");
        } else {
          return store.dispatch("clearReseller");
        }
      },
    }).$mount("#app");
  }
});
